import request from '@/util/request';
import qs from 'qs';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/serverai/page', Object.assign({}, options, { params }));

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/serverai/submit', params, options, {
    'Content-Type': 'application/json',
  });

// 删除
export const delApi = (params, options) =>
  request.post('/api/v4ward/callcenter/serverai/remove', qs.stringify(params), options);

// 编辑
export const updateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/serverai/update', params, options, {
    'Content-Type': 'application/json',
  });

// 关联任务
export const bindTaskApi = (params, options) =>
  request.post('/api/v4ward/callcenter/calltask/relatedtask', params, options, {
    'Content-Type': 'application/json',
  });

// 任务列表
export const getTaskListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/calltask/list', Object.assign({}, options, { params }));
